// assets
import { IconBrandChrome, IconBrandYoutube, IconCalendarEvent } from '@tabler/icons';

const other = {
	id: 'others',
	type: 'group',
	children: [
		{
			id: 'libraryall',
			title: 'ParentEd Library',
			type: 'item',
			icon: IconBrandYoutube,
			url: '/library/all',
			breadcrumbs: false
		},
		{
			id: 'assessments',
			title: 'Assessments',
			type: 'item',
			url: '/assessments',
			icon: IconBrandChrome,
			breadcrumbs: false
		},
		{
			id: 'usersessions',
			title: 'Sessions',
			type: 'item',
			url: '/user/sessions',
			icon: IconCalendarEvent,
			breadcrumbs: false
		}
	]
};

export default other;
